var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryProgramming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 39,
    viewBox: "0 0 56 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4307 9.93068C25.6015 7.75983 25.6015 4.24017 23.4307 2.06932C21.2598 -0.101538 17.7402 -0.101538 15.5693 2.06932L23.4307 9.93068ZM6 19.5L2.06932 15.5693C-0.101538 17.7402 -0.101538 21.2598 2.06932 23.4307L6 19.5ZM15.5693 36.9307C17.7402 39.1015 21.2598 39.1015 23.4307 36.9307C25.6015 34.7598 25.6015 31.2402 23.4307 29.0693L15.5693 36.9307ZM15.5693 2.06932L2.06932 15.5693L9.93068 23.4307L23.4307 9.93068L15.5693 2.06932ZM2.06932 23.4307L15.5693 36.9307L23.4307 29.0693L9.93068 15.5693L2.06932 23.4307Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2458 9.93068C30.075 7.75983 30.075 4.24017 32.2458 2.06932C34.4167 -0.101538 37.9363 -0.101538 40.1072 2.06932L32.2458 9.93068ZM49.6765 19.5L53.6072 15.5693C55.7781 17.7402 55.7781 21.2598 53.6072 23.4307L49.6765 19.5ZM40.1072 36.9307C37.9363 39.1015 34.4167 39.1015 32.2458 36.9307C30.075 34.7598 30.075 31.2402 32.2458 29.0693L40.1072 36.9307ZM40.1072 2.06932L53.6072 15.5693L45.7458 23.4307L32.2458 9.93068L40.1072 2.06932ZM53.6072 23.4307L40.1072 36.9307L32.2458 29.0693L45.7458 15.5693L53.6072 23.4307Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryProgramming);
export default __webpack_public_path__ + "react/media/category-programming.593a6a09f7854e73e679987ddf1d337c.svg";
export { ForwardRef as ReactComponent };